module.exports = __webpack_public_path__ + "img/qushangwang.9a21926f.png";